import { CoreLadderHeader } from '../../../../views';
import './index.styl';

import overall_ladder from './templates/overall_ladder.jst';
import round_by_round from './templates/round_by_round.jst';
import streak_ladder from './templates/streak_ladder.jst';
import view_tips from './templates/view_tips.jst';
import { redirectTo } from '../../../../../../core/utils';
import Preloader from "../../../../../../core/utils/Preloader";
import Radio from "backbone.radio";
const leagueLadderChannel = Radio.channel('league_ladder');

/**
 * @desc CoreLadderHeader Class
 * This class using on comp ladder page ('comps/:comp_id/ladder')
 */
export class LadderHeader extends CoreLadderHeader {
	get defaultTemplateType() {
		return 'overall';
	}

	async initialize() {
		this.tipping = this.getOption( 'tipping' );
		this.league_id = this.getOption( 'league_id' );
		this.rounds = this.getOption( 'rounds' );

		this.model.set( {
			template_type: this.defaultTemplateType,
		} );

		Preloader.show();

		await this.fetchData();
		if (this.rounds.last().get('status') === 'complete') {
			await this.fetchFinalsData();
		}

		const first_final = this.options.fin_matches.toJSON()[0];
		if (first_final && first_final.status !== 'scheduled') {			
			this.rounds.setFinalRoundAsComplete();
			leagueLadderChannel.trigger('set:final:round');
		}


		this.initListeners()
			.updateModel();

		Preloader.hide();
	}

	fetchFinalsData() {
		return this.options.fin_matches.fetch();
	}

	initListeners() {
		super.initListeners();

		this.listenTo(
			this.tipping,
			'user:tips:success',
			this.updateView
		);

		return this;
	}

	getTemplate() {
		let template_type = this.model.get( 'template_type' ),
			status = this.model.get( 'status' );

		if( status !== 'scheduled' ) {
			switch ( template_type ) {
				case 'overall':
					return overall_ladder;
				case 'round-by-round':
					return round_by_round;
				case 'streak':
					return streak_ladder;
				case 'view-tips':
					return view_tips;
				default:
					return overall_ladder;
			}
		}
		else {
			return false;
		}
	}

	updateModel() {


		let rounds = this.rounds.recalculateCompleteRounds( true );
		this.current_round = this.rounds.points_round;

		this.model
			.set( {
				rounds,
				current_round: this.current_round.get('id'),
				matches:       this.tipping.toJSON()
			} )
			.setAvatar();

		return this;
	}

	updateView() {
		this.updateModel()
			.render();
	}

	redirectToMyLeague() {
		redirectTo( '/comps/my-comps' );
	}
}

export default LadderHeader;